'use strict';

var callDateGet = require('../../common/internal/callDateGet');

function getWeekday(d) {
  return callDateGet(d, 'Day');
}

module.exports = getWeekday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/getWeekday.js
// module id = 106
// module chunks = 0